import React from 'react';
import styled from 'styled-components';
import { GlobalStyle, Colors } from 'stylecomponents';
import StatusBlock from './commons/status/StatusBlock';

/**
 * Variables
 */
const THIRD_PARTY_TYPE = {
    MEMBER_CARRIER: '1', // 會員載具歸戶 - 大平台
};

const MESSAGE_TYPE = {
    [THIRD_PARTY_TYPE.MEMBER_CARRIER]: {
        '0': '財政部大平台會員載具歸戶失敗',
    },
};

/**
 * Styled
 */
const TextContent = styled.div`
    text-align: center;

    h3 {
        color: ${Colors.Dark3};
        font-size: 24px;
        line-height: 1.7em;
    }

    p {
        color: ${Colors.Dark4};
        font-size: 20px;
        line-height: 1.7em;
        margin: 10px 0 0;
    }
`;

/**
 * Components
 */
/**
 * 會員載具歸戶 - 大平台 ( 只有錯誤訊息會回傳結果到這頁 )
 * @author Ac
 * @time 2020 / 08 / 19
 */
const MemberCarrier = () => {

    const searchParams = new URLSearchParams(window.location.search);
    const messageId = searchParams.get('msgid');
    const message = searchParams.get('msg') || '';

    return (
        <StatusBlock
            iconElement={<i className='zmdi zmdi-info-outline'></i>}
            textElement={
                <TextContent>
                    <h3>{MESSAGE_TYPE[THIRD_PARTY_TYPE.MEMBER_CARRIER][messageId]}</h3>
                    <p>{message ? window.decodeURIComponent(message) : ''}</p>
                </TextContent>
            }
        />
    );
};

/**
 * 第三方服務溝通結果頁面
 * @author Ac
 * @time 2020 / 08 / 19
 */
const ThirdPartyResultView = props => {

    const { type } = props.match.params;

    let content = null;
    switch (type) {
        case THIRD_PARTY_TYPE.MEMBER_CARRIER: // 會員載具歸戶 - 大平台
            content = <MemberCarrier />;
            break;
        default:
            break
    }

    return (
        <GlobalStyle.SubContainer>
            <GlobalStyle.BasicBlock>
                {content}
            </GlobalStyle.BasicBlock>
        </GlobalStyle.SubContainer>
    );
};

export default ThirdPartyResultView;
